<template>
    <div class="plan-group-toggle-wrapper">
        <FormToggleButton
            :toggleLabelHTML="toggle.label"
            :defaultActive="active"
            :toggleLeftLabel="toggle.left"
            :toggleRightLabel="toggle.right"
            @change="$emit('change', $event)"></FormToggleButton>
    </div>
</template>

<script>
    import FormToggleButton from 'aa/vue/components/FormToggleButton';

    /**
     * The "plain plans / plans of a group" toggle shown by the plan picker and the switch page.
     * `toggle` comes from planGroupMixin ({ group, label, left, right }), `active` is the side to show.
     */
    export default {
        name: 'PlanGroupToggle',
        components: { FormToggleButton },
        props: {
            toggle: {
                type: Object,
                required: true,
            },
            active: {
                type: String,
                required: true,
            },
        },
    };
</script>
